import { NavLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const PrimesTamNav = () => {
  const { t } = useTranslation(['primes']);

  return (
    <NavContainer>
      <NavItem to="/primes/mois">{t('navMonthly')}</NavItem>
      <NavItem to="/primes/annuel">{t('navAnnual')}</NavItem>
    </NavContainer>
  );
};

export default PrimesTamNav;

const NavContainer = styled('nav')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1),
}));

const NavItem = styled(NavLink)(({ theme }) => ({
  padding: `${theme.spacing(0.75)} ${theme.spacing(2)}`,
  borderRadius: '8px',
  textDecoration: 'none',
  fontWeight: 600,
  color: theme.palette.neutral[60],
  border: `1px solid ${theme.palette.neutral[20]}`,
  '&.active': {
    color: theme.palette.red[60],
    borderColor: theme.palette.red[40],
    backgroundColor: theme.palette.red[20],
  },
}));
